export function removeLocalStorage(key: string): void {
    localStorage.removeItem(key)
}
